var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.inited)?_c('AppLoader'):_vm._e(),_c('SystemMessage'),_c(_vm.layout,{tag:"component",staticStyle:{"z-index":"1"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }